import { fetch } from '@/utils/http'
import createTaskVue from '@/views/privacyComputing/components/createTask.vue'

export default {
  //获取区块链列表
  getChainList: params =>
    fetch('get', '/cbaas-service/v1/chainManagement/subScribeChainQueryList', params),
  //获取链客户端信息
  getChainClientInfo: params =>
    fetch('post', '/cbaas-service/v1/multiNodePaillier/queryChainClient', params),
  //新建任务
  createTask: params => fetch('post', '/cbaas-service/v1/multiNodePaillier/createTask', params),
  //任务列表
  getHomoList: params => fetch('post', '/cbaas-service/v1/multiNodePaillier/queryTaskList', params),
  getTaskDetail: params => fetch('post', '/cbaas-service/v1/multiNodePaillier/queryTask', params),
  //加密
  encryptData: params => fetch('post', '/cbaas-service/v1/paillier/encrypt', params),
  incryptAvg: params => fetch('post', '/cbaas-service/v1/multiNodePaillier/avg', params),
  //关闭任务
  closeTasks: params => fetch('post', '/cbaas-service/v1/multiNodePaillier/closeTask', params),
  //上链加密数据
  saveData: params => fetch('post', '/cbaas-service/v1/multiNodePaillier/saveData', params),
  //查询是否安装合约
  getHasContract: params =>
    fetch('post', '/cbaas-service/v1/multiNodePaillier/contractDetact', params),
  installContract: params =>
    fetch('post', '/cbaas-service/v1/multiNodePaillier/contractInstall', params),
  //零知识证明
  //创建任务
  createZeroTask: params =>
    fetch('post', '/cbaas-service/v1/multiNodeBulletproofs/createTask', params),
  //任务详情
  getZeroTaskDetail: params =>
    fetch('post', '/cbaas-service/v1/multiNodeBulletproofs/queryTask', params),
  getZeroList: params =>
    fetch('post', '/cbaas-service/v1/multiNodeBulletproofs/queryTaskList', params),
  //上链加密数据
  saveZeroData: params => fetch('post', '/cbaas-service/v1/multiNodeBulletproofs/saveData', params),
  //解密比较大小
  decryptCompare: params =>
    fetch('post', '/cbaas-service/v1/multiNodeBulletproofs/compare', params),
  //生成证明和承诺
  dataProve: params => fetch('post', '/cbaas-service/v1/bulletproofs/prove', params),
  //关闭任务
  closeZeroTasks: params =>
    fetch('post', '/cbaas-service/v1/multiNodeBulletproofs/closeTask', params),
  //查询是否安装合约
  getZeroHasContract: params =>
    fetch('post', '/cbaas-service/v1/multiNodeBulletproofs/contractDetact', params),
  installZeroContract: params =>
    fetch('post', '/cbaas-service/v1/multiNodeBulletproofs/contractInstall', params)
}
